import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { TooltipProvider } from '@shared/ui';
import { ToastProvider } from '@shared/ui/layout';
import { queryClient } from '@services';
import { I18nProvider } from '@infra/i18n';
import { MotionConfig } from 'framer-motion';

export function Providers({
  children,
  client = queryClient,
}: {
  children: React.ReactNode;
  /**
   * Defaults to the app-wide singleton. Tests pass a fresh client so cached
   * data cannot leak between them and so retries stay off — using the
   * singleton would make a suite's result depend on its run order.
   */
  client?: QueryClient;
}) {
  return (
    <MotionConfig reducedMotion="user">
      <I18nProvider>
        <QueryClientProvider client={client}>
          <TooltipProvider delayDuration={200}>
            <ToastProvider>{children}</ToastProvider>
          </TooltipProvider>
        </QueryClientProvider>
      </I18nProvider>
    </MotionConfig>
  );
}
